import { __decorate, __metadata, __param } from "tslib";
import { injectable, inject } from 'inversify';
import { Symbols } from '@/symbols';
import { extend } from 'vee-validate';
import { splitEmailGroup, splitPatsnap } from '../utils/emails';
import { validateDomain, validateDomains } from '../utils/domain';
import { isName, isSingleIPStartWithLocalAreaNetwork, isStartWithLocalAreaNetwork } from '@/utils/validate';
import '@core/utils/validations/validations';
// eslint-disable-next-line prefer-regex-literals
export const ipv4Reg = new RegExp('^(((25[0-5]|2[0-4]\\d|[1]\\d{2}|[1-9]?\\d|\\(((25[0-5]|2[0-4]\\d|[1]\\d{2}|[1-9]?\\d)\\|?)+\\)|\\((25[0-5]|2[0-4]\\d|[1]\\d{2}|[1-9]?\\d)-(25[0-5]|2[0-4]\\d|[1]\\d{2}|[1-9]?\\d)\\)|\\*)\\.){3}((25[0-5]|2[0-4]\\d|[1]\\d{2}|[1-9]?\\d|\\(((25[0-5]|2[0-4]\\d|[1]\\d{2}|[1-9]?\\d)\\|?)+\\)|\\((25[0-5]|2[0-4]\\d|[1]\\d{2}|[1-9]?\\d)-(25[0-5]|2[0-4]\\d|[1]\\d{2}|[1-9]?\\d)\\)|\\*)))((\\|\\|)((25[0-5]|2[0-4]\\d|[1]\\d{2}|[1-9]?\\d|\\(((25[0-5]|2[0-4]\\d|[1]\\d{2}|[1-9]?\\d)\\|?)+\\)|\\((25[0-5]|2[0-4]\\d|[1]\\d{2}|[1-9]?\\d)-(25[0-5]|2[0-4]\\d|[1]\\d{2}|[1-9]?\\d)\\)|\\*)\\.){3}((25[0-5]|2[0-4]\\d|[1]\\d{2}|[1-9]?\\d|\\(((25[0-5]|2[0-4]\\d|[1]\\d{2}|[1-9]?\\d)\\|?)+\\)|\\((25[0-5]|2[0-4]\\d|[1]\\d{2}|[1-9]?\\d)-(25[0-5]|2[0-4]\\d|[1]\\d{2}|[1-9]?\\d)\\)|\\*)))*$');
function validateNumberInt(number) {
    const re = /^[1-9]\d*$/;
    return re.test(number);
}
let VeeValidateExtendService = class VeeValidateExtendService {
    constructor(i18n) {
        this.i18n = i18n;
    }
    init() {
        // 邮件
        extend('emailGroup', {
            message: (field, params) => {
                const errors = splitEmailGroup(params._value_).errors;
                return this.i18n.t('validate.invalidateEmails', { emails: errors });
            },
            validate: val => {
                return splitEmailGroup(val).errors.length === 0;
            },
        });
        // domain
        extend('domainsGroup', {
            message: (field, params) => {
                const { blackDomains, invalidDomains } = validateDomains(params._value_);
                if (blackDomains) {
                    return this.i18n.t('company_setting.hasBlackDomains', {
                        blackDomains,
                    });
                }
                if (invalidDomains) {
                    return this.i18n.t('company_setting.hasInvalidDomains', {
                        domains: invalidDomains,
                    });
                }
            },
            validate: val => {
                return validateDomains(val).validated;
            },
        });
        extend('domain', {
            message: (field, params) => {
                const { invalidDomain } = validateDomain(params._value_);
                if (invalidDomain) {
                    return this.i18n.t('company_setting.hasInvalidDomains', {
                        domains: invalidDomain,
                    });
                }
            },
            validate: val => {
                return validateDomain(val).validated;
            },
        });
        // number
        extend('numberInt', {
            message: (field, params) => {
                return this.i18n.t('company_setting.numberVaild');
            },
            validate: val => {
                return validateNumberInt(val);
            },
        });
        // ipv4
        extend('ipv4', {
            message: (field, params) => {
                if (isStartWithLocalAreaNetwork(params._value_)) {
                    return this.i18n.t('validate.ipv4LocalAreaNetwork');
                }
                return this.i18n.t('validate.ipv4');
            },
            validate: val => {
                if (isStartWithLocalAreaNetwork(val))
                    return false;
                return ipv4Reg.test(val);
            },
        });
        // 单个ipv4
        extend('singleIpv4', {
            message: (field, params) => {
                if (isSingleIPStartWithLocalAreaNetwork(params._value_)) {
                    return this.i18n.t('validate.ipv4LocalAreaNetwork');
                }
                return this.i18n.t('validate.ipv4');
            },
            validate: val => {
                if (isSingleIPStartWithLocalAreaNetwork(val))
                    return false;
                return ipv4Reg.test(val);
            },
        });
        extend('emailPatsnap', {
            message: (field, params) => {
                const errors = splitPatsnap(params._value_).errors;
                return this.i18n.t('validate.invalidateEmails', { emails: errors });
            },
            validate: val => {
                return splitPatsnap(val).errors.length === 0;
            },
        });
        extend('name', {
            message: () => {
                return this.i18n.t('bootstrap.vee.name');
            },
            validate: val => {
                return isName(val);
            },
        });
    }
};
VeeValidateExtendService = __decorate([
    injectable(),
    __param(0, inject(Symbols.I18n)),
    __metadata("design:paramtypes", [Object])
], VeeValidateExtendService);
export { VeeValidateExtendService };
